export default __webpack_public_path__ + "static/media/back-arrow.a71a08fb.svg";